import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import { isMobile } from 'mobile-device-detect'

Vue.use(Router)

const router = new Router({
    mode: process.env.CORDOVA_PLATFORM ? 'hash' : 'hash',
    base: process.env.NODE_ENV === 'production' ? '' : '',
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue')
        },
        {
            path: '/login',
            name: 'login',
            component: () => import(/* webpackChunkName: "login" */ '@/views/auth/Login.vue')
        },
        {
            path: '/user/me',
            name: 'private-profile',
            component: () => import(/* webpackChunkName: "privateprofile" */ '@/views/user/PrivateProfile.vue')
        },
        {
            path: '/user/:id',
            name: 'public-profile',
            component: () => import(/* webpackChunkName: "publicprofile" */ '@/views/user/PublicProfile.vue')
        },
        {
            path: '/register/step-1',
            name: 'register',
            component: () => import(/* webpackChunkName: "register1" */ '@/views/auth/RegisterOne.vue')
        },
        {
            path: '/register/step-2',
            name: 'registerTwo',
            component: () => import(/* webpackChunkName: "register2" */ '@/views/auth/RegisterTwo.vue')
        },
        {
            path: '/register/step-3',
            name: 'registerThree',
            component: () => import(/* webpackChunkName: "register3" */ '@/views/auth/RegisterThree.vue')
        },
        {
            path: '/search',
            name: 'search',
            component: () => import(/* webpackChunkName: "search" */ '@/views/Search.vue')
        },
        {
            path: '/messages',
            name: 'messages',
            component: () => import(/* webpackChunkName: "messages" */ '@/views/Messages.vue')
        },
        {
            path: '/messages?id=:id',
            name: 'messages',
            component: () => import(/* webpackChunkName: "messages" */ '@/views/Messages.vue')
        },
        {
            path: '/change-password',
            name: 'changePassword',
            component: () => import(/* webpackChunkName: "changePassword" */ '@/views/user/ChangePassword.vue')
        },
        {
            path: '/forgot-password',
            name: 'forgotPassword',
            component: () => import(/* webpackChunkName: "changePassword" */ '@/views/user/ForgotPassword.vue')
        },
        {
            path: '/reset-password/:token',
            name: 'resetPassword',
            component: () => import(/* webpackChunkName: "changePassword" */ '@/views/user/ResetPassword.vue')
        },
        {
            path: '/plans',
            name: 'plans',
            component: () => import(/* webpackChunkName: "plans" */ '@/views/Plans.vue')
        },
        {
            path: '/edit-profile',
            name: 'editProfile',
            component: () => import(/* webpackChunkName: "editProfile" */ '@/views/user/EditProfile.vue')
        },
        {
            path: '/likers-list',
            name: 'listOfLikes',
            component: () => import(/* webpackChunkName: "listOfLikes" */ '@/views/user/ListOfLikes.vue')
        },
        {
            path: '/profiles-viewed',
            name: 'profilesViewed',
            component: () => import(/* webpackChunkName: "profilesViewed" */ '@/views/user/ProfilesViewed.vue')
        },
        {
            path: '/profile-viewers',
            name: 'profileViewers',
            component: () => import(/* webpackChunkName: "profileViewers" */ '@/views/user/ProfileViewers.vue')
        },
        {
            path: '/blocked',
            name: 'blocked',
            component: () => import(/* webpackChunkName: "blocked" */ '@/views/Blocked.vue')
        },
        {
            path: '/blocked-users',
            name: 'blockedUsers',
            component: () => import(/* webpackChunkName: "blockedUsers" */ '@/views/user/BlockedUsers.vue')
        },
        {
            path: '/edit-profile-pictures',
            name: 'editProfilePictures',
            component: () => import(/* webpackChunkName: "editProfilePictures" */ '@/views/user/EditProfilePictures.vue')
        },
        {
            path: '/notifications',
            name: 'notifications',
            component: () => import(/* webpackChunkName: "notifications" */ '@/views/user/Notifications.vue')
        },
        {
            path: '/contact',
            name: 'contact',
            component: () => import(/* webpackChunkName: "contact" */ '@/views/ContactSupport.vue')
        },
        {
            path: '/contact-reseller',
            name: 'contact-reseller',
            component: () => import(/* webpackChunkName: "contactReseller" */ '@/views/ContactReseler.vue')
        },
        {
            path: '/payments',
            name: 'payments',
            component: () => import(/* webpackChunkName: "payments" */ '@/views/Payments.vue')
        },
        {
            path: '/auth/:provider/callback',
            component: {
                template: '<div class="auth-component">ok</div>'
            }
        },
        {
            path: '/terms',
            name: 'terms',
            component: () => import(/* webpackChunkName: "terms" */ '@/views/Terms.vue')
        },
        {
            path: '/privacy-policy',
            name: 'privacyPolicy',
            component: () => import(/* webpackChunkName: "terms" */ '@/views/PrivacyPolicy.vue')
        }
    ]
})

router.beforeEach((to, from, next) => {
    const guardedRoutes = ['/messages', '/edit-profile']
    const token = localStorage.getItem('token')
    if (guardedRoutes.includes(to.fullPath) && !token) {
        isMobile ? next('/login') : next('/')
        return
    }
    const user = store.getters.user

    if (user && to.fullPath !== '/register/step-1') {
        const fullyRegistered = user.options && user.options.find(option => option.type === 'purpose')
        if (!fullyRegistered) {
            next('/register/step-1')
            return
        }
    }
    next()
})

export default router
